<div class="modal-header d-flex align-items-center justify-content-center position-relative">
    <div><span class="font-semibold text-primary">Products</span></div>
    <app-svg-icon [name]="'cross_button_border'" class="cross-button-border"></app-svg-icon>
    <app-svg-icon [name]="'cross'" class="cross-button" [ngClass]="currentHoverEffect"
        (click)="assignAccountProductId(productDetailId)"></app-svg-icon>
</div>
<form ngNativeValidate>
    <div class="modal-body h_18_5rem mx-2">
        <div class="col-12 px-0 d-flex align-items-center mb-2">
            <div class="w-100">
                <app-custom-select2 
                    [whichDropdown]="storageName.PRODUCT_DROPDOWN" 
                    [formModel]=""  
                    [customId]="'productDetailId'"
                    [isDropdownOpen]="true" 
                    (valueChanged)="assignAccountProductId($event)"
                    >
                </app-custom-select2>
            </div>
        </div>
    </div>
</form>